import { useState, useEffect } from 'react';
import { useGlobal } from './global';

export const useCredits = () => {
  const { fox, apiKey } = useGlobal();
  const [loading, setLoading] = useState();
  const [didInit, setDidInit] = useState();
  const [credits, setCredits] = useState();

  useEffect(() => {
    if (!fox) return;
    if (!apiKey) return;

    const update = async () => {
      setLoading(true);
      const balance = await fox.credits.balance.get();
      const conv = (n) => Math.floor((n || 0) / 10) / 100;
      const usd = {
        credits: conv(balance?.credits),
        consumedCredits: conv(balance?.credits),
        remaining: conv(balance?.remaining),
      };
      setCredits({ balance, usd });
      setDidInit(true);
      setLoading(false);
    };

    update();

    const id = setInterval(update, 5000);
    return () => clearInterval(id);
  }, [fox]);

  return { loading, didInit, credits };
};

export const useTransactions = () => {
  const { fox, apiKey } = useGlobal();
  const [loading, setLoading] = useState();
  const [didInit, setDidInit] = useState();
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    if (!fox) return;
    if (!apiKey) return;

    setLoading(true);
    setTransactions([]);

    fox.call('GET', '/api/credits/transactions').then((data) => {
      setLoading(false);
      setDidInit(true);
      setTransactions(data.results);
    });
  }, [fox, apiKey]);

  return { loading, didInit, transactions };
};
